// extracted by mini-css-extract-plugin
export default {"card-wrapper":"CreateMediaCard_card-wrapper__PHMT3","card-inner-wrapper":"CreateMediaCard_card-inner-wrapper__Qp4Wn","card-plus":"CreateMediaCard_card-plus__2I+D2"};